const { dataLayerListener } = require('./data-layer.cjs');
const { alfaPartners } = require('./partners.cjs');
const { platformIdReady } = require('./platform-id-ready.cjs');
const { polyfill } = require('./polyfills.cjs');
const { ytm, ytmCookie, ytmNoScript, ytmSendEvent, ytmSendUserParams } = require('./ytm.cjs');

const getCounters = (url, data) => {
    const { CUSTOM_YTM_ID, ENABLE_COUNTERS } = process.env;
    const isCountersEnabled = ENABLE_COUNTERS === 'true';
    const {
        pageContent: { webAnalytics }
    } = data;
    const enableYtm = isCountersEnabled && CUSTOM_YTM_ID;
    const ytmScripts = [
        ytmNoScript,
        ytmCookie,
        dataLayerListener,
        ytmSendUserParams,
        ytmSendEvent(webAnalytics)
    ];
    const headYTM = enableYtm ? ytm(url) : '';
    const bodyYTM = enableYtm ? ytmScripts.join('') : '';

    return {
        headCounters: [platformIdReady, headYTM, polyfill],
        bodyCounters: [bodyYTM, isCountersEnabled ? alfaPartners(url) : ''],
        endBodyCounters: []
    };
};

module.exports = { getCounters };
